import VerificationInput from "react-verification-input";

import config from "../../app.json";
import axios from "axios";

import AlertComponent from "../../Components/AlertComponent";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import CsWhiteLogo from "../../Assets/Svgs/cs-white-logo.svg";
import AwsLogo from "../../Assets/Svgs/aws-logo.svg";

function RecoverPasswordCode() {
  const [code, setCode] = useState(null);
  const [codeError, setCodeError] = useState(null);
  let navigate = useNavigate();
  const location = useLocation();

  const handleVerification = (e) => {
    e.preventDefault();
    if (!code) setCodeError("Verification Code is required");
    else {
      setCodeError(null);
      navigate("/RecoverPasswordConfirmation", {
        state: {
          email: location.state.email,
          code: code,
        },
        replace: false,
      });
    }
  };

  const handleResendCode = () => {
    axios
      .post(config.API + "/api/user/requestPasswordRecoveryCode", {
        email: location.state.email,
      })
      .then(() => {
        return AlertComponent("Success", "The verification code was re-sent.");
      })
      .catch((error) => {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <div className="prelogin-container">
      <div className="containerLoginForm">
        <Row className="header-login">
          <Col className="col-md-6">
            <img className="cs-logo-login" src={CsWhiteLogo} />
          </Col>
          <Col className="col-md-6">
            <img className="aws-logo-login" src={AwsLogo} />
          </Col>
        </Row>
        <Row className="login-body">
          <Col className="col-md-7 cs-3d-phone">
            <iframe
              src="https://my.spline.design/untitled-c751e6b7fc77254e43fcafa257e796e6/"
              frameBorder="0"
              width="100%"
              height="100%"
            ></iframe>
          </Col>
          <Col className="col-md-5 cs-login-form ">
            <Row>
              <Col className="col-md-12">
                <h2>Verification</h2>
              </Col>
            </Row>
            <Row className="verification-code verificationForm">
              <form onSubmit={handleVerification}>
                <VerificationInput
                  placeholder=" "
                  onChange={setCode}
                  length={6}
                  validChars="0-9"
                  removeDefaultStyles={true}
                  classNames={{
                    container: "verification-code-container",
                    character: "verification-code-character",
                    characterInactive: "verification-code-character-inactive",
                    characterSelected: "verification-code-character-selected",
                  }}
                />

                {codeError ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  >
                    {codeError}
                  </div>
                ) : null}

                <div className="form-group mt-3 loginAlignCenter">
                  <button type="submit" className="btn submitCode col-md-12">
                    Verify Code
                  </button>
                </div>

                <div className="loginAlignCenter">
                  <span className="signUpText">
                    <a className="signUpLink" onClick={handleResendCode}>
                      Re-send my code
                    </a>
                  </span>
                </div>
              </form>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default RecoverPasswordCode;
